import { Injectable, Component, Inject } from "@angular/core";
import { DwAction, DwGridActionConfig, DwDecoratorType, DwActionType, DwActionPreference, DwUiConfigContextBase,
         DwOrmDataServiceToken, DwConfirmDialogConfig, DwOrmDataService, DwMetaDataGridActionState, DwActionResult,
         DwModalService, DwContextService, DwComponentType, DwMetaDataListConfigContext,
         DwMetaDataConfigContext, DwEventService, DwActionButtonComponent } from "@devwareapps/devware-cap";
import { FleetMetaDataItemNames, RoVehicleEntity, FleetVehicleEntity, AuctionEntity } from "../meta-data/fleet-meta-data.service";
import { FleetAuctionContextService } from '../data-contexts/auction-responsibility-context.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import * as moment_ from 'moment';
import { Router } from '@angular/router';
import { DwGridActionHandler } from "@devwareapps/devware-cap/devware-ui-metadata/grid/actions/model/dw-grid-action-handler.model";
const moment = moment_;

@DwAction<DwGridActionConfig>({
    keyName: 'fleet-auction-actions',
    display: 'Fleet - Auction Actions',
    actionType: DwActionType.gridRowAction,
    decoratorType: DwDecoratorType.component,
    isGlobal: false,
    parentItemName:  [ FleetMetaDataItemNames.Auction ],
    allowOnce: true
})
@Component({
    selector: 'fleet-auction-actions',
    styles: [``],
    template: `
        <button [hidden]="responsible != true" (click)="edit()" class="btn-flat">
            <i class="dw-icon-edit-grid hand" title="Edit"></i></button>
        <button [hidden]="true" (click)="delete()" class="btn-flat">
             <i class="dw-icon-delete-grid hand" title="Delete"></i></button>
        <button [hidden]="responsible != false || active == false" (click)="addBid()" class="btn-flat">
            <i class="fas fa-plus-circle hand btn-add-bid-ico" title="Add Bid"></i><span class="btn-add-bid-lbl">Bid</span></button>
`
})
export class FleetAuctionActionsColumnComponent implements DwActionButtonComponent<any, DwMetaDataConfigContext> {
    constructor(
        private router: Router,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private dwModalService: DwModalService,
        private dwContextService: DwContextService) 
    { 
    }
    actionPreference: DwActionPreference<any>;
    actionContext?: any;    
    auction: AuctionEntity = null;
    responsible: boolean = undefined;
    active : boolean = false;

    addBid(){ this.router.navigateByUrl(`/fleet/vehicle-auction/edit/${this.auction.AuctionId}?AddBid`); }
    edit(){ this.router.navigateByUrl(`/fleet/vehicle-auction/edit/${this.auction.AuctionId}`); }
    setupComponent() {
        this.auction = this.auction ?? this.actionContext?.rowData;
        if (this.auction != undefined) {
            this.dwContextService.getContextsAndResolve([FleetAuctionContextService.ContextName], 
                                                        { data: this.auction, respOnly: true })
                                 .subscribe(cxt => {
                                    this.responsible = cxt?.FleetAuctionContext?.Responsible;
                                    this.active = cxt?.FleetAuctionContext?.Active;
                                });
        }
    }
    delete(){
    //     const confirmDialogConfig: DwConfirmDialogConfig = {
    //         message: "Deleting an item cannot be undone. Are you sure you want to delete it?",
    //         title: 'Delete Item?',
    //         showConfirmDialog: true,
    //     };
    //     this.dwModalService.showConfirmDialog(confirmDialogConfig)
    //                .pipe(map(result => 
    //                  {
    //                     if (result){
    //                         this.dataService.deleteEntity(this.auction, true).subscribe();
    //                     }
    //                     return { success: result };
    //                  })).subscribe();

    }

}